(ns app.login.views
  (:require [app.components.buttons.views :as buttons]
            [app.components.headers.views :refer [header]]
            [app.components.icons.views :refer [google-icon outlook-icon]]
            [app.components.input-field.views :refer [input-field
                                                      password-field]]
            [app.events :as app-events]
            [app.home-page.styles :refer [home-page home-page-container
                                          login-app-bar new-workspace-container]]
            [app.login.events :as events]
            [app.routes :as routes]
            [app.subs :as subs]
            [cemerick.url :as url]
            [clojure.string :refer [blank? lower-case upper-case]]
            [clojure.walk]
            [re-com.core :as re-com :refer [alert-box at box h-box throbber
                                            v-box]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reagent.core  :as reagent :refer [atom]]
            [app.login.styles :refer [pwd-field input-hint login-border]]))

(defn login-bar []
  [h-box
   :class (login-app-bar)
   :src   (at)
   :children [[header {:label "Strive" :type :title :size :large  :style {:color "white"
                                                                          :cursor "pointer"}
                       :onClick #(re-frame/dispatch [::app-events/navigate [:home-page]])}]]])

(defn login-panel []
  (reagent/create-class
   {:component-did-mount
    (fn []
      (re-posh/dispatch [::events/remove-login-error]))
    :reagent-render
    (fn []
      (let [text-val (reagent/atom nil)
            password-val (reagent/atom nil)
            action-clicked? (reagent/atom false)]
        (fn []
          (let [{show :error/show error-msg :error/value} @(re-posh/subscribe [::subs/login-error])]
            [box
             :class (home-page)
             :child [v-box
                     :src      (at)
                     :min-height "100vh"
                     :margin "auto"
                     :width "100%"
                     :children [[login-bar]
                                [box
                                 :size "auto"
                                 :justify :center
                                 :align :center
                                 :align-self :center
                                 :child [v-box
                                         :src (at)
                                         :width "100%"
                                         :class (home-page-container)
                                         :justify :start
                                         :align :center
                                         :gap "10px"
                                         :children (if (and (true? @action-clicked?) (false? show))
                                                     [[throbber :size :regular]]
                                                     [[header {:label "Welcome back!" :type :title :size :regular :style {:color "white"}}]
                                                      [v-box
                                                       :src (at)
                                                       :gap "15px"
                                                       :justify :start
                                                       :align :center
                                                       :class (new-workspace-container)
                                                       :children [[box
                                                                   :child [buttons/button {:action :cta
                                                                                           :type :secondary
                                                                                           :title "Sign In With Microsoft"
                                                                                           :icon outlook-icon
                                                                                           :size :xlarge
                                                                                           :width "100%"
                                                                                           :onClick #(do (reset! action-clicked? true)
                                                                                                         (re-posh/dispatch [::events/remove-login-error])
                                                                                                         (re-frame/dispatch [::events/signInWithOutlookAuth]))}]
                                                                   :width "310px"]
                                                                  [box
                                                                   :child [buttons/button {:action :cta
                                                                                           :type :secondary
                                                                                           :title "Sign In With Google"
                                                                                           :icon google-icon
                                                                                           :size :xlarge
                                                                                           :onClick #(do (reset! action-clicked? true)
                                                                                                         (re-posh/dispatch [::events/remove-login-error])
                                                                                                         (re-frame/dispatch [::events/signInWithGoogleAuth]))}]
                                                                   :width "310px"]
                                                                  [h-box
                                                                   :src (at)
                                                                   :width "100%"
                                                                   :align :center
                                                                   :justify :center
                                                                   :children [[:hr
                                                                               {:class  (login-border)}]
                                                                              [header {:label "OR"
                                                                                       :type :small :size :semibold :style {:color "#CACBCC"}}]
                                                                              [:hr
                                                                               {:class  (login-border)}]]]
                                                                  [box
                                                                   :child [input-field {:placeholder "Email"
                                                                                        :disable false
                                                                                        :value text-val
                                                                                        :onChange #(do (reset! text-val %)
                                                                                                       (re-posh/dispatch [::events/add-user-email @text-val]))
                                                                                        :size :xlarge
                                                                                        :change-on-blur? false
                                                                                        :width "100%"}]
                                                                   :width "310px"]
                                                                  [box
                                                                   :child [password-field
                                                                           {:placeholder "Password"
                                                                            :value password-val
                                                                            :size :xlarge
                                                                            :onChange #(reset! password-val %)
                                                                            :change-on-blur? false
                                                                            :new-password? false
                                                                            :width "100%"}]
                                                                   :width "310px"]
                                                                  [buttons/button {:action :cta :type :tertiary
                                                                                   :title "Forgot password?" :size :small
                                                                                   :onClick  #(re-frame/dispatch [::app-events/navigate [:forgot-password]])}]
                                                                  [box
                                                                   :child [buttons/button {:action :cta :type :primary
                                                                                           :title "Sign In" :size :xlarge
                                                                                           :width "100%"
                                                                                           :disable (or (or (nil? @text-val) (blank? @text-val)) (or (nil? @password-val) (blank? @password-val)))
                                                                                           :onClick  #(do (reset! action-clicked? true)
                                                                                                          (re-posh/dispatch [::events/remove-login-error])
                                                                                                          (re-frame/dispatch [::events/signInWithEmail {:email @text-val :password @password-val}]))}]
                                                                   :width "310px"]
                                                                  (when (true? show) [alert-box
                                                                                      :style      {:color             "white"
                                                                                                   :background-color  "#FF4975"
                                                                                                   :border-radius     "5px"
                                                                                                   :width "300px"
                                                                                                   :display "flex" :justify-content "center"}
                                                                                      :padding "10px"
                                                                                      :alert-type :danger
                                                                                      :body error-msg
                                                                                      :closeable? false
                                                                                      :on-close   #(re-posh/dispatch [::events/remove-login-error])])]]
                                                      [h-box
                                                       :align :center
                                                       :justify :center
                                                       :children [[header {:label "No account?"
                                                                           :type :small :size :regular :style {:color "white"}}]
                                                                  [buttons/button {:action :cta :type :tertiary
                                                                                   :title "Sign up" :size :medium :style {:color "white"}
                                                                                   :onClick  #(re-frame/dispatch [::app-events/navigate [:sign-up]])}]]]])]]]]]))))}))



(defn- contains-uppercase? [password]
  (not= (lower-case password) password))

(defn- contains-lowercase? [password]
  (not= (upper-case password) password))

(defn- contains-number? [password]
  (false? (nil? (re-find  #"\d+" password))))

(defn- contains-8char? [password]
  (>= (count password) 8))

(defn- validate-password [password]
  (when-not (nil? password)
    (and (contains-uppercase? password) (contains-lowercase? password) (contains-number? password) (contains-8char? password))))

(defn- validate-password-text [element]
  [:div
   {:class (input-hint)}
   [:div "your password should contain:"]
   (when-not (contains-uppercase? element)
     [:div "Upper case letters"])
   (when-not (contains-lowercase? element)
     [:div "Lower case letters"])
   (when-not (contains-number? element)
     [:div "At least one number"])
   (when-not (contains-8char? element)
     [:div "At least 8 characters"])])

(defn sign-up-panel []
  (reagent/create-class
   {:component-did-mount
    (fn []
      (re-posh/dispatch [::events/remove-login-error]))
    :reagent-render
    (fn []
      (let [text-val (reagent/atom nil)
            password-val (reagent/atom nil)
            action-clicked? (reagent/atom false)]
        (fn []
          (let [{show :error/show error-msg :error/value} @(re-posh/subscribe [::subs/login-error])]
            [box
             :class (home-page)
             :child [v-box
                     :src      (at)
                     :min-height "100vh"
                     :margin "auto"
                     :children [[login-bar]
                                [box
                                 :size "auto"
                                 :justify :center
                                 :align :center
                                 :align-self :center
                                 :child [v-box
                                         :src (at)
                                         :width "100%"
                                         :class (home-page-container)
                                         :justify :start
                                         :align :center
                                         :gap "10px"
                                         :children (if (and (true? @action-clicked?) (false? show))
                                                     [[throbber :size :regular]]
                                                     [[header {:label "Welcome!" :type :title :size :regular :style {:color "white"}}]
                                                      [v-box
                                                       :src (at)
                                                       :gap "15px"
                                                       :justify :start
                                                       :align :center
                                                       :class (new-workspace-container)
                                                       :children [[box
                                                                   :child [buttons/button {:action :cta
                                                                                           :type :secondary
                                                                                           :title "Sign Up With Microsoft"
                                                                                           :icon outlook-icon
                                                                                           :size :xlarge
                                                                                           :width "100%"
                                                                                           :onClick #(do (reset! action-clicked? true)
                                                                                                         (re-posh/dispatch [::events/remove-login-error])
                                                                                                         (re-frame/dispatch [::events/signInWithOutlookAuth]))}]
                                                                   :width "310px"]
                                                                  [box
                                                                   :child [buttons/button {:action :cta
                                                                                           :type :secondary
                                                                                           :title "Sign Up With Google"
                                                                                           :icon google-icon
                                                                                           :size :xlarge
                                                                                           :onClick  #(do (reset! action-clicked? true)
                                                                                                          (re-posh/dispatch [::events/remove-login-error])
                                                                                                          (re-frame/dispatch [::events/signInWithGoogleAuth]))}]
                                                                   :width "310px"]
                                                                  [h-box
                                                                   :src (at)
                                                                   :width "100%"
                                                                   :align :center
                                                                   :justify :center
                                                                   :children [[:hr
                                                                               {:class  (login-border)}]
                                                                              [header {:label "OR"
                                                                                       :type :small :size :semibold :style {:color "#CACBCC"}}]
                                                                              [:hr
                                                                               {:class  (login-border)}]]]
                                                                  [box
                                                                   :child [input-field {:placeholder "Email"
                                                                                        :disable false
                                                                                        :value text-val
                                                                                        :size :xlarge
                                                                                        :onChange #(reset! text-val %)
                                                                                        :change-on-blur? false
                                                                                        :width "100%"}]
                                                                   :width "310px"]
                                                                  [:div
                                                                   {:class (pwd-field)}
                                                                   (when (and (false? (validate-password @password-val)) (> (count @password-val) 1))
                                                                     [validate-password-text @password-val])
                                                                   [box
                                                                    :child [password-field
                                                                            {:placeholder "Password (8-64 characters)"
                                                                             :value password-val
                                                                             :onChange #(reset! password-val %)
                                                                             :size :xlarge
                                                                             :change-on-blur? false
                                                                             :new-password? true
                                                                             :width "100%"}]
                                                                    :width "310px"]]
                                                                  [box :child [buttons/button {:action :cta :type :primary
                                                                                               :title "Sign Up" :size :xlarge
                                                                                               :width "100%"
                                                                                               :disable
                                                                                               (or  (or (nil? @text-val) (blank? @text-val)) (or (nil? @password-val) (blank? @password-val)) (false? (validate-password @password-val)))
                                                                                               :onClick  #(do (reset! action-clicked? true)
                                                                                                              (re-posh/dispatch [::events/remove-login-error])
                                                                                                              (re-frame/dispatch [::events/signUpWithEmail {:email @text-val :password @password-val}]))}]
                                                                   :width "310px"]


                                                                  (when (true? show) [alert-box
                                                                                      :src        (at)
                                                                                      :style      {:color             "white"
                                                                                                   :background-color  "#FF4975"
                                                                                                   :border-radius     "5px"
                                                                                                   :width "300px"
                                                                                                   :display "flex" :justify-content "center"}
                                                                                      :padding "10px"
                                                                                      :alert-type :danger
                                                                                      :body (if (= error-msg "wrong password") "email already in use" error-msg)
                                                                                      :closeable? false
                                                                                      :on-close   #(re-posh/dispatch [::events/remove-login-error])])]]
                                                      [h-box
                                                       :align :center
                                                       :justify :center
                                                       :children [[header {:label "Have an account?"
                                                                           :type :small :size :regular
                                                                           :style {:color "white"}}]
                                                                  [buttons/button {:action :cta :type :tertiary
                                                                                   :title "Sign in" :size :medium
                                                                                   :style {:color "white"}
                                                                                   :onClick  #(re-frame/dispatch [::app-events/navigate [:login]])}]]]])]]]]]))))}))

(defn forgot-password-panel []
  (reagent/create-class
   {:component-did-mount
    (fn []
      (re-posh/dispatch [::events/remove-login-error]))
    :reagent-render
    (fn []
      (let [{email :user/email} @(re-posh/subscribe [::subs/user-email])
            text-val (reagent/atom email)
            sent-password? (reagent/atom false)]
        (fn []
          (let [{show :error/show error-msg :error/value} @(re-posh/subscribe [::subs/login-error])]
            [box
             :class (home-page)
             :child [v-box
                     :src      (at)
                     :min-height "100vh"
                     :margin "auto"
                     :children [[login-bar]
                                [box
                                 :size "auto"
                                 :justify :center
                                 :align :center
                                 :align-self :center
                                 :child [v-box
                                         :src (at)
                                         :width "400px"
                                         :class (home-page-container)
                                         :justify :start
                                         :align :center
                                         :gap "10px"
                                         :children [[header {:label "Forgot Password?" :type :title :size :regular :style {:color "white"}}]
                                                    [v-box
                                                     :src (at)
                                                     :gap "20px"
                                                     :justify :start
                                                     :align :center
                                                     :class (new-workspace-container)
                                                     :children [(if (false? @sent-password?)
                                                                  [v-box
                                                                   :justify :center
                                                                   :align :start
                                                                   :children [[header {:label "Enter your email address and we'll send you a link to reset your password." :type :normal :size :bold}]]]
                                                                  [header {:label "We send you an email which contains a link to reset your password." :type :normal :size :bold}])
                                                                (when (true? show) [alert-box
                                                                                    :src        (at)
                                                                                    :style      {:color             "white"
                                                                                                 :background-color  "#FF4975"
                                                                                                 :border-radius     "5px"
                                                                                                 :width "300px"
                                                                                                 :display "flex" :justify-content "center"}
                                                                                    :padding "10px"
                                                                                    :alert-type :danger
                                                                                    :body error-msg
                                                                                    :closeable? false
                                                                                    :on-close   #(re-posh/dispatch [::events/remove-login-error])])
                                                                (if (false? @sent-password?) [input-field {:placeholder "Email"
                                                                                                           :disable false
                                                                                                           :value text-val
                                                                                                           :onChange #(reset! text-val %)
                                                                                                           :size :xlarge
                                                                                                           :width "320px"}]
                                                                    [:div])
                                                                [box :child [buttons/button {:action :cta :type :primary
                                                                                             :width "100%"
                                                                                             :title "Send Password Reset Link" :size :xlarge
                                                                                             :onClick  #(do (reset! sent-password? true)
                                                                                                            (re-frame/dispatch [::events/reset-password {:email @text-val}]))}]
                                                                 :width "320px"]
                                                                [buttons/button {:action :cta :type :tertiary
                                                                                 :title "Go Back" :size :medium
                                                                                 :onClick #(re-frame/dispatch [::app-events/navigate [:login]])}]]]]]]]]]))))}))

(defn reset-password-email-panel []
  [box
   :class (home-page)
   :child [v-box
           :src      (at)
           :min-height "100vh"
           :margin "auto"
          ;;  :width "1400px"
           :children [[login-bar]
                      [box
                       :size "auto"
                       :justify :center
                       :align :center
                       :align-self :center
                       :child [v-box
                               :src (at)
                               :width "100%"
                               :class (home-page-container)
                               :justify :start
                               :align :center
                               :gap "10px"
                               :children [[header {:label "Forgot Password?" :type :title :size :regular :style {:color "white"}}]
                                          [v-box
                                           :src (at)
                                           :gap "20px"
                                           :justify :start
                                           :align :center
                                           :class (new-workspace-container)
                                           :children [[header {:label "We send you an email which contains a link to reset your password." :type :normal :size :bold}]
                                                      [buttons/button {:action :cta :type :tertiary
                                                                       :title "Go Back" :size :medium
                                                                       :onClick #(re-frame/dispatch [::app-events/navigate [:login]])}]]]]]]]]])

(defn reset-password-panel []
  (let [password-val (reagent/atom nil)
        route-params (:query (url/url (-> js/window .-location .-href)))
        {show :error/show error-msg :error/value} @(re-posh/subscribe [::subs/login-error])]
    [box
     :class (home-page)
     :child [v-box
             :src      (at)
             :min-height "100vh"
             :margin "auto"
            ;;  :width "1400px"
             :children [[login-bar]
                        [box
                         :size "auto"
                         :justify :center
                         :align :center
                         :align-self :center
                         :child [v-box
                                 :src (at)
                                 :width "100%"
                                 :class (home-page-container)
                                 :justify :start
                                 :align :center
                                 :gap "10px"
                                 :children [[header {:label "Reset Password" :type :title :size :regular :style {:color "white"}}]
                                            [v-box
                                             :src (at)
                                             :gap "20px"
                                             :justify :start
                                             :align :center
                                             :class (new-workspace-container)
                                             :children [[:input
                                                         {:id "password"
                                                          :style {:display "none"}
                                                          :type "password"
                                                          :name "fakepasswordremembered"}]
                                                        [box
                                                         :child [password-field
                                                                 {:placeholder "Password (8-64 characters)"
                                                                  :value password-val
                                                                  :onChange #(reset! password-val %)
                                                                  :size :xlarge
                                                                  :new-password? true
                                                                  :width "100%"}]
                                                         :width "310px"]
                                                        [box :child [buttons/button
                                                                     {:action :cta :type :primary
                                                                      :title "Reset Password" :size :xlarge
                                                                      :onClick  #(re-frame/dispatch [::events/password-change {:password @password-val :code (:oobCode (clojure.walk/keywordize-keys route-params))}])}]
                                                         :width "310px"]]]
                                            (when (true? show) [alert-box
                                                                :src        (at)
                                                                :style      {:color             "#333"
                                                                             :background-color  "rgba(255, 0, 0, 0.1)"
                                                                             :border-radius     "5px"
                                                                             :border-top        "none"
                                                                             :border-right      "none"
                                                                             :border-bottom     "none"
                                                                             :border-left       "4px solid rgba(255, 0, 0, 0.8)"}
                                                                :padding "10px"
                                                                :alert-type :danger
                                                                :body error-msg
                                                                :closeable? true
                                                                :on-close   #(re-posh/dispatch [::events/remove-login-error])])]]]]]]))
(defn reset-password-success-panel []
  [box
   :class (home-page)
   :child [v-box
           :src      (at)
           :min-height "100vh"
           :margin "auto"
          ;;  :width "1400px"
           :children [[login-bar]
                      [box
                       :size "auto"
                       :justify :center
                       :align :center
                       :align-self :center
                       :child [v-box
                               :src (at)
                               :width "100%"
                               :class (home-page-container)
                               :justify :start
                               :align :center
                               :gap "10px"
                               :children [[header {:label "Reset Password" :type :title :size :regular :style {:color "white"}}]
                                          [v-box
                                           :src (at)
                                           :gap "20px"
                                           :justify :start
                                           :align :center
                                           :class (new-workspace-container)
                                           :children [[header {:label "Password successfully changed" :type :normal :size :bold}]
                                                      [buttons/button
                                                       {:action :cta :type :tertiary
                                                        :title "Go To App" :size :medium
                                                        :onClick  #(re-frame/dispatch [::app-events/navigate [:login]])}]]]]]]]]])


(defn verify-email-panel []
  (reagent/create-class
   {:component-did-mount
    (fn []
      (re-posh/dispatch [::events/remove-login-error]))
    :reagent-render
    (fn []
      (let [text-val (reagent/atom nil)
            {email :user/email} @(re-posh/subscribe [::subs/user-email])]
        (fn []
          (let [{show :error/show error-msg :error/value} @(re-posh/subscribe [::subs/login-error])]
            [box
             :class (home-page)
             :child [v-box
                     :src      (at)
                     :min-height "100vh"
                     :margin "auto"
                     :children [[login-bar]
                                [box
                                 :size "auto"
                                 :justify :center
                                 :align :center
                                 :align-self :center
                                 :child [v-box
                                         :src (at)
                                         :width "100%"
                                         :class (home-page-container)
                                         :justify :start
                                         :align :center
                                         :gap "10px"
                                         :children [[header {:label "Now. please check your inbox" :type :title :size :regular :style {:color "white"}}]
                                                    [v-box
                                                     :src (at)
                                                     :gap "20px"
                                                     :justify :start
                                                     :align :center
                                                     :class (new-workspace-container)
                                                     :children [[header {:label "We send you an email which contains a link to reset your password." :type :normal :size :bold}]
                                                                (when (true? show) [alert-box
                                                                                    :src        (at)
                                                                                    :style     {:color             "white"
                                                                                                :background-color  "#FF4975"
                                                                                                :border-radius     "5px"
                                                                                                :display "flex" :justify-content "center"}
                                                                                    :padding "10px"
                                                                                    :alert-type :danger
                                                                                    :body error-msg
                                                                                    :closeable? true
                                                                                    :on-close   #(re-posh/dispatch [::events/remove-login-error])])
                                                                [box
                                                                 :child [input-field {:placeholder "Verification code" :disable false :value text-val
                                                                                      :onChange #(reset! text-val %)
                                                                                      :width "270px"}]
                                                                 :width "270px"]
                                                                [h-box
                                                                 :gap "10px"
                                                                 :children [[buttons/button
                                                                             {:action :cta :type :secondary
                                                                              :title "Resend Code"
                                                                              :size :medium
                                                                              :style {:width "133px"}
                                                                              :onClick  #(re-frame/dispatch [::events/resend-code {:email email}])}]
                                                                            [buttons/button
                                                                             {:action :cta :type :primary
                                                                              :title "Submit" :size :medium
                                                                              :style {:width "133px"}
                                                                              :disable (or (nil? @text-val) (blank? @text-val))
                                                                              :onClick  #(re-frame/dispatch [::events/verify-email {:email email :verification_code @text-val}])}]]]]]
                                                    [buttons/button
                                                     {:action :cta :type :tertiary
                                                      :title "Go Back" :size :medium
                                                      :style {:color "white"}
                                                      :onClick  #(re-frame/dispatch [::app-events/navigate [:login]])}]]]]]]]))))}))

(defmethod routes/panels :login-panel [] [login-panel])
(defmethod routes/panels :forgot-password-panel [] [forgot-password-panel])
(defmethod routes/panels :sign-up-panel [] [sign-up-panel])
(defmethod routes/panels :reset-password-panel [] [reset-password-panel])
(defmethod routes/panels :reset-password-success-panel [] [reset-password-success-panel])
(defmethod routes/panels :reset-password-email-panel [] [reset-password-email-panel])
(defmethod routes/panels :verify-email-panel [] [verify-email-panel])

